import { GetTransactionsResponse } from "components/CreditCardAccount/Transactions/types";
import { withPath } from "library/api/api";
import { getHref } from "./httpMethods";

export type ApiGetResponse = {
  data: GetTransactionsResponse;
};

export const transactionPath = (id) =>
  withPath(`v1/accounts/${id}/transactions`);

export type GetTransactionsParams = {
  href: string | null;
};

export const getTransactions = async ({ href }: GetTransactionsParams) =>
  href !== null
    ? getHref<GetTransactionsResponse>(href)
    : {
        data: {
          transactions: [],
          links: [],
        },
      };
